import { LANGUAGE } from '@/env';
import { getCurrencyCode } from '@/utilities/language';
import type { CurrencyCode } from '@/utilities/price';

export const CURRENT_CURRENCY: CurrencyCode = getCurrencyCode(LANGUAGE);
